import React, { useMemo } from "react"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { observer } from "mobx-react"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { usePTKMStore } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
import { TReactSelectOption } from "components/ProjectNonSpecificComponents/Elements/FormBuilder/FormBuilder"
import { TPickList } from "components/ProjectSpecificComponents/Interfaces/DataInterface"
import DeadlineFormFieldsSelects from "./DeadlineForm.FieldsSelects"
import DeadlineFormRLAKRColumn from "./DeadlineForm.RLAKRColumn"

interface Props {}

export const DeadlinesForm = observer(({}: Props) => {
	const ptkmStore = usePTKMStore()
	const { picklist } = ptkmStore?.mainFieldOptions
	const { fieldKey, secondFieldKey } = ptkmStore.ptkmConfig.deadlines.priorityField

	const getExtraPropsArr = (obj: TReactSelectOption[] | undefined): any[] => {
		if (!obj || obj.length < 1 || !obj[0]?.extraProp) {
			return []
		} else {
			return JSON.parse(obj[0]?.extraProp)
		}
	}

	const priorityStatuses = useMemo(() => {
		const frstPriority = picklist && picklist.filter((s) => s.value == fieldKey)
		const scndPriority = picklist && picklist.filter((s) => s.value == secondFieldKey)

		return {
			frstPriority: getExtraPropsArr(frstPriority),
			scntPriority: getExtraPropsArr(scndPriority),
		}
	}, [fieldKey, secondFieldKey, picklist])

	const { frstPriority, scntPriority } = priorityStatuses

	return (
		<HyperDiv direction="column" padding=".5rem 0" spaceBetweenElems="2.25rem">
			<DeadlineFormFieldsSelects />

			{frstPriority?.length > 0 && (
				<HyperDiv
					direction="row"
					padding="1rem"
					style={{
						backgroundColor: "var(--light-light-gray)",
					}}
					width="w-full"
				>
					<div id="main-proprity-statuses" className="pr-2" style={{ width: "fit-content" }}>
						<Whitespace x={scntPriority.length > 0 ? "5.7" : "4"} />
						{frstPriority?.map(({ label }: TPickList) => (
							<div
								className="pr-1 center mb-1 pt-2 font-bold text-right"
								key={label}
								style={{ height: 38 }}
							>
								{label}
							</div>
						))}
					</div>

					<div className="flex flex-row overflow-x-auto w-full">
						{/* If single dimension */}
						{!(scntPriority.length > 0) && (
							<DeadlineFormRLAKRColumn frstPriority={frstPriority} scntPriority={scntPriority} />
						)}

						{/* If two dimensional */}
						{scntPriority.length > 0 &&
							scntPriority.map(({ value, label }: TReactSelectOption, index: number) => {
								return (
									<React.Fragment key={String(index + label + value)}>
										<DeadlineFormRLAKRColumn
											frstPriority={frstPriority}
											scntPriority={scntPriority}
											headingLabel={label}
											headingValue={value}
										/>
									</React.Fragment>
								)
							})}
					</div>
				</HyperDiv>
			)}
		</HyperDiv>
	)
})

export default DeadlinesForm
